import React, { useRef, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from "../../helpers/useStores";
import { styled, darkTheme } from '../../stitches.config';
import Heading from '../atoms/Heading';
import { bodyLarge, h1, h3 } from '../commonStyles/Fonts';
import PodcastSeriesBox from '../components/PodcastSeriesBox';
import PodcastsList from '../components/PodcastsList';

import Loader from '../../components/Loader';
import Error from '../../components/Error';
import { IPodcastSerie } from '../../stores/PodcastStore';
import { IPodcast } from '../types/Podcast';
import Footer from "../components/Footer"

const PodcastPage: React.FC = observer(() => {

    const { PodcastStore } = useStores();

    useEffect(() => { PodcastStore.fetchPodcasts() }, []);

    const recentSeries: IPodcastSerie[] = PodcastStore.recentSeries;
    const latestEpisodes: IPodcast[] = PodcastStore.latestEpisodes;

    if (PodcastStore.status === "error")
        return <Error error={PodcastStore.message} />;
    if (PodcastStore.status === "loading" || !recentSeries || !latestEpisodes)
        return <Loader />;

    return (
        <>
            <HighlightPodcastsSeries>
                <section className="container">
                    <Heading title={"Podcasty"} style={"default-white"} specialHeading={true} />
                    <PodcastsSeries>
                        {recentSeries.map((serie, idx) => (
                            <PodcastSeriesBox
                                {...serie}
                                key={idx}
                            />
                        ))}
                    </PodcastsSeries>
                </section>
            </HighlightPodcastsSeries>
            <section className="container">
                <div className="row">
                    <AdPlaceholder className="col-md-3 col-md-push-9">
                        #adContent
                    </AdPlaceholder>
                    <div className="col-md-9 col-lg-8 col-md-pull-3">
                        <PodcastsList
                            leadOnMobile={true}
                            items={latestEpisodes}
                            title={"Ostatnio dodane odcinki"}
                        />
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );

});

export default PodcastPage;

const HighlightPodcastsSeries = styled('div', {
    background: "$grayscale100Fixed",
    padding: "2.75rem 0 5rem",
    color: "$grayscale0Fixed"
});

const PodcastsSeries = styled('div', {
    display: 'grid',
    gap: '2.4rem',
    color: "$grayscale100Fixed",
    gridTemplateColumns: 'repeat(1, 1fr)',
    '@bp3': {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '@bp4': {
        gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@bp5': {
        gridTemplateColumns: 'repeat(4, 1fr)',
    }
});

const AdPlaceholder = styled('div', {
    padding: '4rem 0',
    background: '$grayscale25',
    '@bp2': {
        background: 'transparent',
    },
    '@bp4': {
        padding: 0,
        marginTop: '160px'
    }
});